if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");
	linkTag.setAttribute("rel", "preload");
	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
		linkTag.crossOrigin = "anonymous";
	}

	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"runtime": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"common":1,"vendors-node_modules_pnpm_swiper_11_2_0_node_modules_swiper_modules_autoplay_css":1,"vendors-node_modules_pnpm_swiper_11_2_0_node_modules_swiper_modules_effect-fade_css":1,"src_pages_dashboard_Dashboard_jsx-node_modules_pnpm_react-show-more-text_1_7_1_react_18_3_1_n-194166":1,"src_pages_ebook_EbookListing_jsx":1,"src_pages_ebook_EbookDetails_jsx-node_modules_pnpm_swiper_11_2_0_node_modules_swiper_modules_-999b68":1,"src_pages_uiv3_epaper_EpaperDetails_jsx-node_modules_pnpm_swiper_11_2_0_node_modules_swiper_m-67af3d":1,"src_pages_vault_Vault_jsx-node_modules_pnpm_react-bootstrap_2_10_7__types_react_19_0_3_react--8dd06b":1,"src_pages_helpAndSupport_HelpAndSupport_jsx-node_modules_pnpm_object-assign_4_1_1_node_module-c02820":1,"src_pages_medwiki_MedwikiListing_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_dayjs_plugi-01520f":1,"src_pages_userProfile_CpdReview_jsx-node_modules_pnpm_react-bootstrap_2_10_7__types_react_19_-41c92e":1,"src_pages_grandRounds_GrandRoundListing_jsx":1,"src_pages_discussRefer_DiscussRefer_jsx":1,"src_pages_discussRefer_hospitalProfile_jsx-node_modules_pnpm_react-bootstrap_2_10_7__types_re-33b65a":1,"src_pages_discussRefer_CaseDetails_jsx":1,"src_pages_discussRefer_Activities_jsx":1,"src_pages_clinicalVideo_ClinicalVideoList_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_da-d3e5a7":1,"src_pages_channel_ChannelLanding_jsx":1,"src_pages_medwikiV2_TopRatedMedwikiListing_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_d-50eba7":1,"src_pages_channel_ChannelLandingV2_jsx-node_modules_pnpm_react-show-more-text_1_7_1_react_18_-33d57a":1,"src_pages_uiv3_channel_ChannelProfile_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_dayjs_-6089ca":1,"src_pages_discussRefer_ReferThankyou_jsx":1,"src_pages_session_AllSessionList_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_dayjs_plugi-167689":1,"src_pages_election_ElectionLanding_jsx":1,"src_pages_election_CandidateSelection_jsx":1,"src_pages_election_VotingSummary_jsx":1,"src_pages_election_MobileVerification_jsx":1,"src_pages_notification_Notification_jsx":1,"src_pages_doctube_doctubeProfileManagement_components_listing_DoctubeListingVideos_jsx-src_pa-f98674":1,"src_pages_doctube_doctubeProfileManagement_DoctubeDashboard_jsx-node_modules_pnpm_react-calen-9f0dd5":1,"src_pages_doctube_doctubeProfileManagement_DoctubeVideoUpload_jsx":1,"src_pages_doctube_doctubeProfileManagement_DoctubeManagePlaylist_jsx":1,"src_pages_clinicalVideo_ClinicalVideoLanding_jsx-node_modules_pnpm_react-bootstrap_2_10_7__ty-6ee291":1,"src_pages_Search_SearchResult_jsx-node_modules_pnpm_react-bootstrap_2_10_7__types_react_19_0_-3881e2":1,"src_pages_Search_SearchList_jsx-node_modules_pnpm_react-bootstrap_2_10_7__types_react_19_0_3_-029bb0":1,"src_pages_telemedLite_TelemedLite_jsx-src_pages_telemedLite_images_telemadePhone_png-src_page-d1b113":1,"src_pages_certificates_UploadCertificate_jsx":1,"src_pages_certificates_CertificatesListing_jsx":1,"src_pages_grTraining_TrainingLanding_jsx":1,"src_pages_grTraining_TrainingListing_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_dayjs_p-7358e1":1,"src_pages_grTraining_TrainingContent_jsx":1,"src_pages_grTraining_TrainingSummary_jsx":1,"src_pages_medwikiV2_MedwikiLandingV2_jsx":1,"src_pages_medwikiV2_MedwikiDetailsV2_jsx":1,"src_pages_certificates_CertificateDetails_jsx-node_modules_pnpm_react-bootstrap_2_10_7__types-262e87":1,"src_pages_medwiki_MedwikiLanding_jsx":1,"src_pages_spq_SPQlanding_jsx-node_modules_pnpm_react-bootstrap_2_10_7__types_react_19_0_3_rea-3a89a8":1,"src_pages_sessionOutlet_SessionDetailsOutlet_jsx":1,"src_pages_sessionOutlet_LiveSessionOutlet_jsx-node_modules_pnpm_react-bootstrap_2_10_7__types-e77acf":1,"src_pages_multidaySession_PhotoBooth_jsx":1,"src_pages_uiv3_profile_Profile_jsx":1,"src_pages_userProfile_UserProfileBkp_jsx-node_modules_pnpm_react-bootstrap_2_10_7__types_reac-3c462d":1,"src_pages_speciality_SpecialityLanding_jsx":1,"src_pages_medwikiV2_MostCommentedMedwikiListing_jsx-node_modules_pnpm_dayjs_1_11_13_node_modu-b6d289":1,"vendors-node_modules_pnpm_react-datepicker_4_25_0_react-dom_18_3_1_react_18_3_1_node_modules_-4e938a":1,"src_pages_ddi_DrugToDrugInteraction_jsx":1,"src_pages_share_MedwikiShare_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_dayjs_plugin_cu-c1c64c":1,"src_pages_share_PollShare_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_dayjs_plugin_custo-92cb85":1,"src_pages_share_QuizShare_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_dayjs_plugin_custo-bfea82":1,"src_pages_share_SessionShare_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_dayjs_plugin_cu-cbe972":1,"src_pages_share_ebookShare_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_dayjs_plugin_cust-fe1bd7":1,"src_pages_share_ElectionShare_jsx-src_pages_share_images_voteCardBg_png":1,"src_pages_share_ClinicalVideosShare_jsx-node_modules_pnpm_dayjs_1_11_13_node_modules_dayjs_pl-35019d":1,"src_pages_sessionOutlet_SessionWaitingroomOutlet_jsx":1,"vendors-node_modules_pnpm_swiper_11_2_0_node_modules_swiper_modules_effect-cards_css":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

var oldTags = [];
var newTags = [];
var applyHandler = (options) => {
	return { dispose: () => {
		for(var i = 0; i < oldTags.length; i++) {
			var oldTag = oldTags[i];
			if(oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
		}
		oldTags.length = 0;
	}, apply: () => {
		for(var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
		newTags.length = 0;
	} };
}
__webpack_require__.hmrC.miniCss = (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) => {
	applyHandlers.push(applyHandler);
	chunkIds.forEach((chunkId) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if(!oldTag) return;
		promises.push(new Promise((resolve, reject) => {
			var tag = createStylesheet(chunkId, fullhref, oldTag, () => {
				tag.as = "style";
				tag.rel = "preload";
				resolve();
			}, reject);
			oldTags.push(oldTag);
			newTags.push(tag);
		}));
	});
}

// no prefetching

// no preloaded